import { TFunction } from 'i18next';

const RATE_ERROR_CODES = [
  'RATE_PACKAGING_ITEM_REQUIRED',
  'RATE_PACKAGING_ITEMS_INCOMPLETE',
  'MULTIPLE_PACKAGING_RATE_ITEMS',
  'INVALID_RATE_ITEM_DATA',
  'INVALID_RATE_ITEM_TYPE',
] as const;

type RateErrorCode = (typeof RATE_ERROR_CODES)[number];

function isRateErrorCode(code: string): code is RateErrorCode {
  return (RATE_ERROR_CODES as readonly string[]).includes(code);
}

export function translateRateError(error: unknown, t: TFunction): string {
  const err = error as {
    response?: { data?: { message?: string; errorCode?: string } };
    message?: string;
  };

  const errorCode = err?.response?.data?.errorCode;
  const apiMessage = err?.response?.data?.message;

  if (errorCode && isRateErrorCode(errorCode)) {
    const translationKey = `errors.codes.${errorCode}`;
    const translated = t(translationKey, { defaultValue: '' });
    if (translated && translated !== translationKey) {
      return translated;
    }
  }

  if (apiMessage) {
    return apiMessage;
  }

  return err?.message || t('toast.createError');
}
